export default "/images/vendor/flag-icons/flags/1x1/eg.svg?f5d0ce62e32a9176ed5dbfce3cd89808";